function RichardsonOrderEditor() {}

RichardsonOrderEditor.events = {
    isInit: true,

    init: function() {
        var funcs = RichardsonOrderEditor.funcs;
        var that = this;

        if (that.isInit) {
            $("#right-pane-column").on('click', '.richardson-footer .uniform-summary-preview', that.onShowSummary);
            $("#richardson-order-summary").on('click', ".update-order", that.onUpdateDesignOrder);

            that.isInit = false;
        }
    },

    onShowSummary: function() {
        RichardsonOrderEditor.funcs.showLoader();
        RichardsonOrderEditor.funcs.prepareThumbnails();
        UIkit.modal("#richardson-order-summary").show();
    },

    onUpdateDesignOrder: function() {
        RichardsonOrderEditor.funcs.showLoader();
        SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
            if (response.success) {
                RichardsonOrderEditor.funcs.onUpdateOrderItem();
            } else {
                ub.utilities.info("ERROR WHILE UPDATING SAVED DESIGN");
                RichardsonOrderEditor.funcs.onErrorSavingDesign();
            }
        }, function(error) {
            funcs.onErrorSavingDesign();
        })
    }
}

RichardsonOrderEditor.isCompleted = function() {
    if (typeof ub.config.order_status !== "undefined") {
        if (ub.config.order_status === "completed" || ub.config.order_status === "shipped") {
            return true;
        }
    }

    return false;
}

RichardsonOrderEditor.statusChecker = function(callback, delay = 100) {
    if (RichardsonOrderEditor.isCompleted()) {
        _.delay(function() {
            callback();
        }, delay)
    } else {
        return;
    }
}

RichardsonOrderEditor.funcs = {
    prepareThumbnails: function() {
        ub.front_view.visible = true;
        ub.back_view.visible = true;
        ub.left_view.visible = true;
        ub.right_view.visible = true;

        ub.funcs.deactivateMoveTool();

        ub.current_material.settings.thumbnails = {
            front_view: "",
            back_view: "",
            left_view: "",
            right_view: "",
        }

        if (typeof ub.data.previousThumbnails === "undefined") {
            ub.data.previousThumbnails = {
                front_view: "",
                back_view: "",
                left_view: "",
                right_view: "",
            }
        }

        this.uploadThumbnailUniformPreview("front_view")
        this.uploadThumbnailUniformPreview("back_view")
        this.uploadThumbnailUniformPreview("left_view")
        this.uploadThumbnailUniformPreview("right_view")
    },

    uploadThumbnailUniformPreview: function(view) {
        var _dataUrl = ub.getThumbnailImage(view);
        ub.data.previousThumbnails[view] = _dataUrl;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            data: JSON.stringify({ dataUrl: _dataUrl }),
            url: ub.config.host + "/saveLogo",
            dataType: "json",
            type: "POST",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
            success: function (response){
                if(response.success) {
                    ub.current_material.settings.thumbnails[view] = response.filename;
                    $("#richardson-order-summary .order-design-preview ." + view + " img").attr('src', '');
                    $("#richardson-order-summary .order-design-preview ." + view + " img").attr('src', response.filename);

                    if (ub.funcs.thumbnailsUploaded()) {
                        RichardsonOrderEditor.funcs.onShowSummaryOfDesign();
                    }
                } else {
                    ub.utilities.info('Error generating thumbnail for ' + view);
                    ub.utilities.info(response.message);
                }
            },

            error: function(error) {
                ub.utilities.info(error);
            }
        });
    },

    onShowSummaryOfDesign: function() {
        if (ub.config.design_type === "revised") {
            RichardsonOrderEditor.funcs.generateNewPDF();
        } else {
            RichardsonOrderEditor.funcs.prepareRevisedDesign();
        }
    },

    // Update Order Item 
    onUpdateOrderItem: function() {
        RichardsonOrderEditor.funcs.postUpdateOrderItem(function(res) {
            if (res.success) {
                RichardsonOrderEditor.funcs.onSuccessUpdatingDesignOrder();
            } else {
                RichardsonOrderEditor.funcs.onErrorUpdatingOrderDesign();
            }
        }, function(err) {
            ub.utilities.info(err)
            RichardsonOrderEditor.funcs.onErrorUpdatingOrderDesign();
        });
    },

    postUpdateOrderItem: function(successHandler, errorHandler) {
        var _url = ub.config.api_host + '/api/order_item/update';
        var data = {
            "parent_order_item_id": ub.config.order_item,
            "order_id": ub.config.orderCode,
            "factory_order_id": null,
            "pid": null,
            "item_id": ub.current_material.material.item_id,
            "description": ub.current_material.material.name,
            "builder_customizations": JSON.stringify(ub.current_material.settings),
            "design_sheet": ub.current_material.settings.pdfOrderForm,
            "set_group_id": null,
            "status": "new",
            "shipped_date": "0000-00-00",
            "esd": "0000-00-00",
            "questions": null,
            "roster": JSON.stringify(RichardsonOrderEditor.funcs.prepareRoster()),
            "attached_files": "[]",
            "additional_attachments": null,
            "notes": null,
            "brand": "richardson",
            "application_type": ub.config.uniform_application_type,
            "customizer_style_id": ub.current_material.material.id,
            "shipping": null
        }

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {
                "accessToken": ub.user ? ub.user.headerValue : null
            },
            
            success: successHandler,    

            erorr: errorHandler
        });
    },

    // Create new Saved Design data and PDF file
    prepareRevisedDesign: function() {
        // Get saved design data
        var designPayload = SaveDesign.prepareSaveDesignPayload();
        SaveDesign.postSaveDesign(designPayload, function(response) {
            ub.current_material.settings.savedDesignID = response.sd_id;
            ub.current_material.settings.design_number_magento = response.sd_id;
            RichardsonOrderEditor.funcs.generateNewPDF();
        }, function(error) {
            RichardsonOrderEditor.funcs.onErrorSavingDesign();
        })
    },

    // Create New PDF file
    generateNewPDF: function() {
        PdfPanel.pdfBuilder(function(response) {
            if (response.success) {
                RichardsonOrderEditor.funcs.onSuccessPDF(response);
            } else {
                RichardsonOrderEditor.funcs.onErrorPDF();
            }
        }, function(error) {
            RichardsonOrderEditor.funcs.onErrorPDF();
        });
    },

    onSuccessPDF: function(response) {
        ub.current_material.settings.uniformPreviewPdf = response.pdfUrl;
        ub.current_material.settings.pdfOrderForm = response.pdfUrl;
        ub.data.rosterIsChange = false;

        $("#richardson-order-summary a.download-pdf-btn").attr("href", "");
        $("#richardson-order-summary a.download-pdf-btn").attr("href", response.pdfUrl);
        RichardsonOrderEditor.funcs.hideLoader();
    },

    onErrorPDF: function() {
        // PDF Error Message
        var pdfErrorMessage = 'Something went wrong while generating the PDF. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
        UIkit.modal("#richardson-order-summary").hide();
        ub.funcs.showNotification(pdfErrorMessage, "danger", 3000);
    },

    onErrorSavingDesign: function() {
        var saveDesignError = 'Something went wrong while saving your design. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
        UIkit.modal("#richardson-order-summary").hide();
        ub.funcs.showNotification(saveDesignError, "danger", 3000);
    },

    onErrorUpdatingOrderDesign: function() {
        ub.funcs.showNotification(
            "Something went wrong while updating your design order. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.",
            "danger",
            3000
        );

        funcs.hideLoader();
    },

    onSuccessUpdatingDesignOrder: function() {
        RichardsonOrderEditor.funcs.hideLoader();
        UIkit.modal("#richardson-order-summary").hide();
        ub.funcs.showNotification("Design successfully updated. Redirecting to order item page.", "success", 3000);

        _.delay(function() {
            var redirect = ub.config.host + '/richardson/administrations/orders/' + ub.config.orderCode;
            window.location.href = redirect;
        }, 2000)
    },

    prepareRoster: function() {
        var rosters = [];

        _.each(ub.current_material.settings.roster, function(roster) {
            rosters.push({
                "Size": roster.size,
                "Number": roster.number,
                "lastname": roster.lastname,
                "Sample": 0,
                "LastNameApplication": "N/A",
                "SleeveCut": "Motion",
                "Quantity": roster.quantity,
                "tag_id": typeof roster.tagid !== "undefined" ? roster.tagid : "",
                "inseam":  typeof roster.inseam !== "undefined" ? RichardsonOrderEditor.funcs.transformInseam(roster.inseam) : ""
            });
        });

        return rosters;
    },

    transformInseam: function(inseam) {
        if (inseam.includes("-1")) {
            return "-1";
        } else if (inseam.includes("-2")) {
            return "-2";
        } else if (inseam.includes("+1")) {
            return "+1";
        } else if (inseam.includes("+2")) {
            return "+2";
        } else {
            return inseam;
        }
    },

    showLoader: function() {
        $("#richardson-order-summary .save-design-loading").removeClass("uk-hidden");
        $("#richardson-order-summary .order-summary-main-container").addClass("uk-hidden");
    },

    hideLoader: function() {
        $("#richardson-order-summary .save-design-loading").addClass("uk-hidden");
        $("#richardson-order-summary .order-summary-main-container").removeClass("uk-hidden");
    }
}